import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { IDocument } from './models/document';
import useHttpClient from './useHttpClient';

export interface IAttachDocDataReq {
  documentId: { native: number; };
  projectId: { native: number; };
  folderId: { native: number; };
}

export interface IAttachDocPayload {
  addDocumentToProject: (payload: IAttachDocDataReq) => Promise<IDocument>;
  loading: boolean;
  error?: Error;
  called: boolean;
  document?: IDocument;
}

const useMutateAttachDocToProject = (): IAttachDocPayload => {
  const httpClient = useHttpClient();
  const [called, setCalled] = useState(false);

  const {
    mutate: addDocumentToProject,
    data: document,
    error,
    isPending: loading,
  } = useMutation<IDocument, Error, IAttachDocDataReq>({
    mutationFn: async ({ documentId, projectId, folderId }: IAttachDocDataReq) => {
      const response = await httpClient.post(
        `/projects/${projectId.native}/documents/${documentId.native}?folderId=${folderId.native}`
      );
      return response.data;
    },
  });

  const addDocumentToProjectWithPromise = (payload: IAttachDocDataReq) => {
    setCalled(true);
    return new Promise<IDocument>((resolve, reject) => {
      addDocumentToProject(payload, {
        onSuccess: (data) => resolve(data),
        onError: (err) => reject(err),
      });
    });
  };

  return {
    addDocumentToProject: addDocumentToProjectWithPromise,
    error: error as Error | undefined,
    loading,
    called,
    document: !error && document ? document : undefined,
  };
};

export default useMutateAttachDocToProject;
